import { getQueryStringValue } from '../utils/getQueryStringValue';
import uuid from 'uuid/v4';
import { RAID_QUERY_PARAM, RAID_STORAGE_KEY } from '../index';

export const storeRAID = () => {
  const queryStringValue = getQueryStringValue(RAID_QUERY_PARAM);

  if (queryStringValue !== '') {
    window.localStorage.setItem(RAID_STORAGE_KEY, queryStringValue);
    return;
  }

  if (window.localStorage.getItem(RAID_STORAGE_KEY)) {
    return;
  }

  window.localStorage.setItem(RAID_STORAGE_KEY, uuid());
};
